<eds-panel theme="dark" edsSpacing="lg" hasBackgroundGradient="true">
  <div edsGrid>
    <div edsRow>
      <div edsCol>
        <!-- breadcrumbs  area -->
        <eds-breadcrumbs
          [items]="breadcrumbs"
          theme="dark"
          [removeBottomSpacing]="true"
        >
        </eds-breadcrumbs>
      </div>
    </div>
  </div>

  <!--fund filters-->
  <ft-fund-filters
    edsSpacing="lg"
    [componentConfiguration]="componentConfiguration"
    [menu]="menu"
    [productNumberofFilteredData]="numberofFilteredData"
    [productTotalNumberOfData]="totalNumberOfData"
    [isLoaded]="isPopulated"
    [showDownloadExcelButton]="showDownloadExcelButton"
    (downloadExcel)="downloadExcelHandler()"
  ></ft-fund-filters>
</eds-panel>

<div class="ppss">
  <div edsGrid>
    <ng-container>
      <div edsRow>
        <div edsCol edsPadding edsPaddingTop="xxl">
          <ng-container *ngIf="canShowResults; else signIn">
            <div
              edsFlexbox
              alignItems="center"
              justifyContent="space-between"
              [edsSpacing]="(isHandheld$ | async) ? 'md' : 'none'"
              *ngIf="numberofFilteredData !== 0"
              id="ppssScrollPosition"
            ></div>
            <ng-container *ngIf="performanceStatusCaveat">
              <eds-proximal
                edsSpacing="lg"
                edsPadding
                edsPaddingBottom="sm"
                [placement]="performanceStatusCaveat"
              ></eds-proximal>
              <br />
            </ng-container>

            <!-- Proximal caveat and fav only toggle -->
            <div
              edsFlexbox
              justifyContent="space-between"
              alignItems="baseline"
            >
              <eds-proximal
                edsSpacing="lg"
                [placement]="placementTop"
              ></eds-proximal>

              <div *ngIf="showFavoritesOnlySwitch">
                <span>{{ "products.show-favorites-toggle" | translate }}</span>
                <eds-switch
                  id="favoritesOnlySwitch"
                  [disabled]="false"
                  [label]="'products.show-favorites-toggle' | translate"
                  [labelOff]="'products.off' | translate"
                  [labelOn]="'products.on' | translate"
                  [state]="favoriteOnlySwitchState"
                  (switchPressed)="onFavoritesOnlyToggle($event)"
                  ariaLabelledbyStr="favoritesOnlySwitchLabel"
                  labelId="favoritesOnlySwitchLabel"
                ></eds-switch>
              </div>
            </div>

            <!-- Hide the tabs and grid, when fav only toggle is active with no data -->
            <!-- Intentionally kept, below condition here for feasibility -->
            <div
              *ngIf="
                (showFavoritesOnlySwitch &&
                  favoriteOnlySwitchState === 'on' &&
                  totalNumberOfData) ||
                  (showFavoritesOnlySwitch &&
                    favoriteOnlySwitchState === 'off') ||
                  !showFavoritesOnlySwitch;
                else noFavFundsMessage
              "
            >
              <ft-ppss-performance
                *ngIf="
                  showTabContent['PERFORMANCE'] && hidePerformanceTabHeading
                "
                [active]="selected === 'PERFORMANCE'"
                [isHandheld]="isHandheld$ | async"
              >
              </ft-ppss-performance>

              <eds-tabs [followFocus]="true" [isNavigation]="true">
                <eds-tab
                  *ngIf="tabs.showPerformance && !hidePerformanceTabHeading"
                  [heading]="'products.performance-tab' | translate"
                  [active]="currentTable === 'PERFORMANCE'"
                  (selected)="onSelected('PERFORMANCE')"
                >
                  <ft-ppss-performance
                    *ngIf="showTabContent['PERFORMANCE']"
                    [active]="selected === 'PERFORMANCE'"
                    [isHandheld]="isHandheld$ | async"
                  >
                  </ft-ppss-performance>
                </eds-tab>
                <!-- Fund Identifiers Start -->
                <eds-tab
                  *ngIf="tabs.showFundIdentifiers"
                  [heading]="'products.fundIdentifiers-tab' | translate"
                  [active]="currentTable === 'FUNDIDENTIFIERS'"
                  (selected)="onSelected('FUNDIDENTIFIERS')"
                >
                  <ft-ppss-fundIdentifiers
                    *ngIf="showTabContent['FUNDIDENTIFIERS']"
                    [active]="selected === 'FUNDIDENTIFIERS'"
                    [isHandheld]="isHandheld$ | async"
                  ></ft-ppss-fundIdentifiers>
                </eds-tab>
                <eds-tab
                  *ngIf="tabs.showYield"
                  [heading]="yieldTabName | translate"
                  [active]="currentTable === 'YIELD'"
                  (selected)="onSelected('YIELD')"
                >
                  <ft-ppss-yields
                    *ngIf="showTabContent['YIELD']"
                    [active]="selected === 'YIELD'"
                    [isHandheld]="isHandheld$ | async"
                  ></ft-ppss-yields>
                </eds-tab>
                <eds-tab
                  *ngIf="tabs.showRatings"
                  [heading]="'products.ratings-tab' | translate"
                  [active]="currentTable === 'RATINGS'"
                  (selected)="onSelected('RATINGS')"
                >
                  <ft-ppss-ratings
                    *ngIf="showTabContent['RATINGS']"
                    [active]="selected === 'RATINGS'"
                    [isHandheld]="isHandheld$ | async"
                  ></ft-ppss-ratings>
                </eds-tab>
                <!-- Fund Price Start -->
                <eds-tab
                  *ngIf="tabs.showPrice"
                  [heading]="'products.price-tab' | translate"
                  [active]="currentTable === 'PRICE'"
                  (selected)="onSelected('PRICE')"
                >
                  <ft-ppss-price
                    [active]="selected === 'PRICE'"
                    [isHandheld]="isHandheld$ | async"
                  >
                  </ft-ppss-price>
                </eds-tab>
              </eds-tabs>
              <!--hide pagination and dropdown-->
              <div
                class="print-hidden"
                edsFlexbox
                alignItems="center"
                justifyContent="space-between"
                [edsSpacing]="'lg'"
                *ngIf="numberofFilteredData !== 0"
              >
                <div edsSpacing="none">
                  <eds-pagination
                    [prevPageText]="'products.previous' | translate"
                    [nextPageText]="'products.next' | translate"
                    [pages]="numberOfPages$ | async"
                    (pageChanged)="onPageChanged($event)"
                  ></eds-pagination>
                </div>
                <!-- Dropdown for Bottom-->
                <eds-dropdown
                  *ngIf="(isHandheld$ | async) !== true"
                  ariaLabel="Dropdown"
                  [id]="'ItemsPerPageBottomDD'"
                  [label]="'products.items-per-page' | translate"
                  [items]="itemsPerPageBottomOption"
                  [preselectedValue]="pageSize"
                  (dropdownChange)="onDropdownChange($event)"
                  edsPadding
                  edsPaddingLeft="none"
                  edsPaddingTop="lg"
                ></eds-dropdown>
              </div>
            </div>

            <!-- Display no fav only template when toggle state is 'on' without any data -->
            <ng-template edsGrid #noFavFundsMessage>
              <div class="container">
                <div edsRow>
                  <div edsCol>
                    <div edsPadding edsPaddingAll="lg">
                      <div edsSpacing="md">
                        <eds-icon
                          type="bookmark-inactive"
                          size="xlarge"
                        ></eds-icon>
                      </div>
                      <eds-title edsSpacing="lg" size="h3" theme="dark">
                        {{ "products.no-fav-message" | translate }}
                      </eds-title>
                      <eds-title edsSpacing="sm" size="h6">
                        {{ "products.no-result-suggestion" | translate }}
                      </eds-title>
                      <ul
                        class="list--unordered"
                        edsList
                        innerHTML="{{
                          'products.no-fav-message-list' | translate
                        }}"
                      ></ul>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <!-- / Dropdown -->
    </ng-container>
  </div>
</div>

<ng-template #signIn>
  <ft-sign-in
    [inputParameters]="{
      skin: 'Basic 2 Columns',
      legacy: false,
      signOut: false
    }"
  ></ft-sign-in>
</ng-template>
